<template>
  <div
    v-if="visivel"
    class="cli-pesq-overlay"
    @keydown.esc.stop.prevent="fechar"
  >
    <div class="cli-pesq-modal">
      <header class="cli-pesq-modal__header">
        <h3 class="cli-pesq-modal__title">
          <i class="fas fa-user-friends"></i> Pesquisa avançada de clientes
        </h3>
        <button class="cli-pesq-modal__close" @click="fechar">×</button>
      </header>

      <div class="cli-pesq-modal__filters">
        <input
          ref="termoInput"
          v-model="termo"
          type="text"
          class="cli-pesq-modal__input"
          placeholder="Nome, CPF/CNPJ, código ou telefone..."
          @input="onBuscar"
          @keydown.enter.prevent="onEnter"
          @keydown.down.prevent="navegar(1)"
          @keydown.up.prevent="navegar(-1)"
        />
      </div>

      <div class="cli-pesq-modal__body">
        <div v-if="buscando" class="cli-pesq-modal__loading">
          <i class="fas fa-spinner fa-spin"></i> Buscando...
        </div>
        <div v-else-if="!resultados.length && termo.length >= 2" class="cli-pesq-modal__vazio">
          <i class="fas fa-search-minus"></i> Nenhum cliente encontrado.
        </div>
        <div v-else-if="!resultados.length" class="cli-pesq-modal__hint">
          Digite ao menos 2 caracteres para buscar.
        </div>

        <table v-else class="cli-pesq-modal__tabela">
          <thead>
            <tr>
              <th>Código</th>
              <th>Nome / Razão Social</th>
              <th>CPF/CNPJ</th>
              <th>Telefone</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(c, idx) in resultados"
              :key="(c.id_pessoa || c.id || c.cnpj_cpf || '') + '-' + idx"
              ref="resultadoRows"
              :class="{ 'cli-pesq-modal__row--ativa': idx === selectedIdx }"
              :aria-selected="idx === selectedIdx ? 'true' : 'false'"
              @mouseenter="selectedIdx = idx"
              @click="confirmar(c)"
              @dblclick="confirmar(c)"
            >
              <td>{{ c.codigo || c.id_pessoa || c.id || '—' }}</td>
              <td>{{ nomeCliente(c) }}</td>
              <td>{{ c.cnpj_cpf || c.cpf || c.cnpj || '—' }}</td>
              <td>{{ c.telefone || c.celular || c.fone || '—' }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <footer class="cli-pesq-modal__footer">
        <span class="cli-pesq-modal__hint-foot">
          <i class="fas fa-keyboard"></i> Use ↑ ↓ para navegar · Enter para selecionar · ESC para fechar
        </span>
        <button class="cli-pesq-modal__btn cli-pesq-modal__btn--cancel" @click="fechar">
          Fechar
        </button>
      </footer>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import ClienteLocalRepository from "@/modules/PdvDesktop/repositories/ClienteLocalRepository";

export default {
  name: "ClientePesquisaAvancadaModal",

  props: {
    visivel: { type: Boolean, default: false },
  },

  data() {
    return {
      termo: "",
      resultados: [],
      buscando: false,
      selectedIdx: 0,
    };
  },

  created() {
    this.onBuscar = _.debounce(this._buscar, 350);
  },

  watch: {
    visivel(v) {
      if (v) {
        this.termo = "";
        this.resultados = [];
        this.selectedIdx = 0;
        this.$nextTick(() => this.$refs.termoInput && this.$refs.termoInput.focus());
      }
    },
  },

  methods: {
    nomeCliente(c) {
      return c.nome_fantasia || c.nome || c.razao_social || c.cnpj_cpf || "—";
    },

    async _buscar() {
      const t = (this.termo || "").trim();
      if (t.length < 2) {
        this.resultados = [];
        this.selectedIdx = 0;
        return;
      }
      this.buscando = true;
      try {
        this.resultados = (await ClienteLocalRepository.search(t)) || [];
        this.selectedIdx = 0;
      } catch (e) {
        console.error("[ClientePesquisaAvancadaModal] erro:", e);
        this.resultados = [];
      } finally {
        this.buscando = false;
      }
    },

    navegar(delta) {
      if (!this.resultados.length) return;
      const n = this.resultados.length;
      this.selectedIdx = (this.selectedIdx + delta + n) % n;
      this.$nextTick(() => {
        const rows = this.$refs.resultadoRows || [];
        const row = Array.isArray(rows) ? rows[this.selectedIdx] : rows;
        if (row && typeof row.scrollIntoView === "function") {
          row.scrollIntoView({ block: "nearest" });
        }
      });
    },

    onEnter() {
      if (!this.resultados.length) return;
      const c = this.resultados[this.selectedIdx] || this.resultados[0];
      if (c) this.confirmar(c);
    },

    confirmar(cliente) {
      this.$emit("selecionar", cliente);
    },

    fechar() {
      this.$emit("fechar");
    },
  },
};
</script>

<style scoped>
.cli-pesq-overlay {
  position: fixed; inset: 0;
  background: rgba(0,0,0,0.55);
  display: flex; align-items: center; justify-content: center;
  z-index: 4100;
}
.cli-pesq-modal {
  background: #fff; border-radius: 8px;
  width: 100%; max-width: 820px; max-height: 86vh;
  box-shadow: 0 12px 32px rgba(0,0,0,0.3);
  display: flex; flex-direction: column; overflow: hidden;
}
.cli-pesq-modal__header {
  display: flex; justify-content: space-between; align-items: center;
  padding: 14px 20px; border-bottom: 1px solid #e5e7eb;
}
.cli-pesq-modal__title { margin: 0; font-size: 17px; color: #1f2937; }
.cli-pesq-modal__title i { color: #0891b2; margin-right: 6px; }
.cli-pesq-modal__close {
  background: transparent; border: 0; font-size: 24px; cursor: pointer; color: #6b7280;
}
.cli-pesq-modal__filters { padding: 12px 20px; border-bottom: 1px solid #f1f5f9; }
.cli-pesq-modal__input {
  width: 100%; padding: 10px 12px; border: 1px solid #cbd5e1; border-radius: 6px; font-size: 15px;
}
.cli-pesq-modal__body { padding: 0; flex: 1; overflow: auto; min-height: 220px; }
.cli-pesq-modal__loading,
.cli-pesq-modal__vazio,
.cli-pesq-modal__hint {
  text-align: center; padding: 30px 20px; color: #64748b;
}
.cli-pesq-modal__tabela { width: 100%; border-collapse: collapse; font-size: 15px; }
.cli-pesq-modal__tabela thead th {
  background: #f8fafc; text-align: left; padding: 8px 12px;
  border-bottom: 1px solid #e2e8f0; font-weight: 600; color: #475569;
  position: sticky; top: 0;
}
.cli-pesq-modal__tabela tbody td {
  padding: 8px 12px; border-bottom: 1px solid #f1f5f9; color: #1f2937;
}
.cli-pesq-modal__tabela tbody tr { cursor: pointer; }
.cli-pesq-modal__tabela tbody tr:hover:not(.cli-pesq-modal__row--ativa) td {
  background: #ecfeff;
}
.cli-pesq-modal__tabela tbody .cli-pesq-modal__row--ativa td {
  background: #0e7490;
  border-bottom-color: #155e75;
  color: #fff;
  font-weight: 700;
}
.cli-pesq-modal__tabela tbody .cli-pesq-modal__row--ativa td:first-child {
  box-shadow: inset 5px 0 0 #164e63;
}
.cli-pesq-modal__footer {
  display: flex; justify-content: space-between; align-items: center;
  padding: 12px 20px; background: #f9fafb; border-top: 1px solid #e5e7eb;
}
.cli-pesq-modal__hint-foot { font-size: 14px; color: #6b7280; }
.cli-pesq-modal__btn {
  padding: 8px 16px; border-radius: 6px; border: 0; cursor: pointer; font-weight: 500;
}
.cli-pesq-modal__btn--cancel { background: #e5e7eb; color: #374151; }
.cli-pesq-modal__btn--cancel:hover { background: #d1d5db; }
</style>
